import React, { FC } from 'react';
import { useOverviewBackLink } from 'src/models/procurements/hooks';
import { useTenderNav } from 'src/models/procurements/TenderNav/hooks';
import { BackButton } from 'src/common';

export const BackToButton: FC = () => {
  const { data } = useTenderNav();
  const isBidding = data?.isBidding;
  const bidId = data?.bid?.id;
  const tenderId = data?.id;

  const { get: getBackLink, reset } = useOverviewBackLink();
  const backLink = getBackLink({ isBidding: isBidding ?? false, id: isBidding ? bidId ?? '' : tenderId ?? '' });

  return <BackButton href={backLink} onClick={reset} />;
};

export default BackToButton;
